import { FilterHandlerBase } from './base/filter-handler-base';
import {
  AdvancedFilterName,
  FilterOptions,
  FilterPassParams,
  InclusiveExclusiveFilterModel
} from '../filter-types';
import { FilterResultFacade } from '../filter-result-facade';
import { OptionsType } from '../../issue/maturity';
import { getObligor } from '../../../utils/issuer-summary';

export class ObligorAdvancedFilterHandler extends FilterHandlerBase {
  get name(): string {
    return AdvancedFilterName.obligor;
  }

  get isInclusiveExclusive(): boolean {
    return true;
  }

  getFilterOptions(filterOptions: FilterOptions): any {
    return filterOptions.obligors;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    const obligor = params.filters[this.name];
    const data = params.deal;
    const dealObligor = getObligor(data);
    const isObligorFilterPassed: boolean = obligor
      ? ((obligor.model as InclusiveExclusiveFilterModel).values as string[]).some(
          (filter: string) =>
            dealObligor ? dealObligor === filter : filter === OptionsType.Blank
        )
      : true;

    result.applyDealFilerResult(
      data.id, 
      this.name, 
      isObligorFilterPassed
    );
    return isObligorFilterPassed;
  }
}